<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <img src="static\img\icon.jpeg" width="100%"/>
        </div>
        <div class="col-md-8">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-body">    
                <form @submit.prevent="handleSubmit()">
                  <b-form-fieldset
                    description="Please enter your email"
                    label="Reset Password"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-input type="email" placeholder="Enter your email" name="email" v-validate="'required'" v-model="email"></b-form-input>
                    <small class="text-danger" v-show="errors.has('email')">
                      {{ errors.first('email') }}
                    </small>                      
                  </b-form-fieldset>     
                  <!-- <b-button size="lg" type="submit" variant="primary">Primary</b-button>           -->
                  <div style="display:flex;justify-content:center;margin-left: 2rem">
                  <!-- <vue-recaptcha sitekey="6LegG08cAAAAAEAUCQrtE-izJAFz-LyoARyujZEQ" :loadRecaptchaScript="true"> -->
                  <vue-button-spinner class="btn" 
                  style="
                    background-color: #20a8d8;
                    color: white;
                    border-radius: 6px;
                    width:150px;
                    "
                    :is-loading="isLoading" 
                    :disabled="isLoading"
                    type="submit"
                    >
                    <span>Kirim</span>
                  </vue-button-spinner>
                  <router-link :to="'/login'" class="btn btn-danger"><i class="fa fa-remove"></i> Cancel</router-link>
                  <!-- <button type="submit"> tes </button>                    -->
                  <!-- </vue-recaptcha>                     -->
                  </div>
                </form>
              </div>
            </div> 
          </div>    
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueButtonSpinner from 'vue-button-spinner'
import swal from 'sweetalert'
// import VueRecaptcha from 'vue-recaptcha'

export default {
  data () {
    return {
      email: '',
      isLoading: false
    }
  },
  components: {
    VueButtonSpinner
  },
  methods: {
    handleSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isLoading = true
          var data = {
            email: this.email
          }
          this.$http.post('sendPasswordResetLink', data).then(() => {
            this.isLoading = false
            swal('success', 'Berhasil mengirim email!', 'success')
          }).catch(() => {
            this.isLoading = false
            swal('error', 'Email tidak ditemukan', 'error')
          })
        }
        this.isLoading = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ResetPassword.vue?70182906